export default "__VITE_ASSET__BrlP0BQq__"